import {
  CDBSidebar,
  CDBSidebarContent,
  CDBSidebarFooter,
  CDBSidebarHeader,
  CDBSidebarMenu,
  CDBSidebarMenuItem,
} from "cdbreact";
import { NavLink, useLocation } from "react-router-dom";
import React from "react";
import { useTranslation } from "react-i18next";

import { getStaffId } from "../../axios/CurrentMedicalStaffManager";

import { useStateContext } from "../../contextProvider";

import './Sidebar.types.css';

export const AdminSidebar = () => {
  const { t } = useTranslation();

  const { adminPage, setAdminPage } = useStateContext()

  return (
    <div
      className={`app`}
      style={{ display: "flex", height: "100%", overflow: "scroll initial" }}
    >
      <CDBSidebar textColor="#204770" backgroundColor="rgb(170, 170, 170)">
        <CDBSidebarHeader
            style={{
              backgroundColor: "rgb(201, 201, 201)",
              height: "60px"
            }}

            prefix={<i className="fa fa-bars fa-large"></i>}>
          <a
            href="/"
            className="text-decoration-none"
            style={{ color: "inherit" }}
          >
            {t("Menu")}
          </a>
        </CDBSidebarHeader>

        <CDBSidebarContent className="sidebar-content">
          <CDBSidebarMenu>
            <NavLink
              to="/dashboard_admin"
              end

              onClick={() => {
                localStorage.setItem('admin_page', 'dashboard')
                setAdminPage('dashboard')
              }}
            >
              <CDBSidebarMenuItem icon="chart-line" className="sidebar-icon-large"
              style={
                adminPage === 'dashboard' ? {
                  backgroundColor:"white", color: '#204770', fontWeight: 600, whiteSpace: "normal", wordWrap: "break-word"
                } : {fontWeight:600, whiteSpace: "normal", wordWrap: "break-word"}
              }
              >
                {t("dashboard")}
              </CDBSidebarMenuItem>
            </NavLink>

            <NavLink
              to="/all_doctors"
              onClick={() => {
                localStorage.setItem('admin_page', 'all_doctors')
                setAdminPage('all_doctors')
              }}
              end
            >
              <CDBSidebarMenuItem icon="user-md" className="sidebar-icon-large"
              style={
                adminPage === 'all_doctors' ? {
                  backgroundColor:" white", color: '#204770', fontWeight: 600, whiteSpace: "normal", wordWrap: "break-word"
                } : {fontWeight:600, whiteSpace: "normal", wordWrap: "break-word"}
              }
              >
                {t("manage_doctors")}
              </CDBSidebarMenuItem>
            </NavLink>

            <NavLink
              to="/all_patients"
              onClick={() => {
                localStorage.setItem('admin_page', 'all_patients')
                setAdminPage('all_patients')
              }}
              end
            >
              <CDBSidebarMenuItem icon="users" className="sidebar-icon-large"
              style={
                adminPage === 'all_patients' ? {
                  backgroundColor:" white", color: '#204770', fontWeight: 600, whiteSpace: "normal", wordWrap: "break-word"
                } : {fontWeight:600, whiteSpace: "normal", wordWrap: "break-word"}
              }
              >
                {t("manage_patients")}
              </CDBSidebarMenuItem>
            </NavLink>

            <NavLink
              to="/pending_doctor_requests"
              end
              onClick={() => {
                localStorage.setItem('admin_page', 'pending_requests')
                setAdminPage('pending_requests')
              }}
            >
              <CDBSidebarMenuItem icon="user-plus" className="sidebar-icon-large"
              style={
                adminPage === 'pending_requests' ? {
                  backgroundColor:"white", color: '#204770', fontWeight: 600, whiteSpace: "normal", wordWrap: "break-word"
                } : {fontWeight:600, whiteSpace: "normal", wordWrap: "break-word"}
              }
              >
                {t("pending_requests")}
              </CDBSidebarMenuItem>
            </NavLink>

            <NavLink
              to="/pending_profile_changes"
              end
              onClick={() => {
                localStorage.setItem('admin_page', 'pending_profile_changes')
                setAdminPage('pending_profile_changes')
              }}
            >
              <CDBSidebarMenuItem icon="user-edit" className="sidebar-icon-large"
              style={
                adminPage === 'pending_profile_changes' ? {
                  backgroundColor:"white", color: '#204770', fontWeight: 600, whiteSpace: "normal", wordWrap: "break-word"
                } : {fontWeight:600, whiteSpace: "normal", wordWrap: "break-word"}
              }
              >
                {t("pending_profile_changes")}
              </CDBSidebarMenuItem>
            </NavLink>

          </CDBSidebarMenu>
        </CDBSidebarContent>
      </CDBSidebar>
    </div>
  );
};

export const DoctorSidebar = () => {
  const location = useLocation();
  const isPatientsActive = location.pathname.startsWith("/patients");
  const isProfileActive = location.pathname === "/doctor_profile";
  const { t } = useTranslation();


  const { selectedPatient, setSelectedPatient, selectedPatientData,
     setSelectedPatientData, doctorPage, setDoctorPage, setAdminPage } = useStateContext()


  return (
    <div
      className={`app`}
      style={{ display: "flex", height: "100%", overflow: "scroll initial" }}
    >
      <CDBSidebar textColor="#204770" backgroundColor="rgb(170, 170, 170)" maxWidth="300px">
        <CDBSidebarHeader
            style={{
              backgroundColor: "rgb(201, 201, 201)",
              height: "60px"
            }}

            prefix={<i className="fa fa-bars fa-large"></i>}>
          <a
            href="/"
            className="text-decoration-none"
            style={{ color: "inherit" }}
          >
            {t("Menu")}
          </a>
        </CDBSidebarHeader>

        <CDBSidebarContent className="sidebar-content">
          <CDBSidebarMenu>
            <NavLink
              to="/patients"
              onClick={() => {
                setSelectedPatient(undefined)
                setSelectedPatientData(undefined)
                setDoctorPage(undefined)
                setAdminPage(undefined)

                localStorage.removeItem('patient_id')
                localStorage.removeItem('staff_id')
                localStorage.removeItem('patient_data')
                localStorage.removeItem('doctor_page')
                localStorage.removeItem('admin_page')
                localStorage.removeItem("patient_name");
                localStorage.removeItem("patient_surname");
              }}
              end
            >
              <CDBSidebarMenuItem icon="user" className="sidebar-icon-large activeClicked"
              >
                {t("patients")}
              </CDBSidebarMenuItem>
            </NavLink>
            
            
            { 
              selectedPatient !== undefined && selectedPatient !== null && selectedPatient !== '' ?
              (<NavLink
                to="/patients/user_details"
                state={{
                  medicalStaffId: Number(getStaffId()),
                  patientId: selectedPatient,
                  patientData: selectedPatientData
                }}
                onClick={() => {
                  localStorage.setItem('doctor_page', 'details')
                  setDoctorPage('details')
                }}
                // className={() => (isPatientsActive ? "activeClicked" : "none")}
              >
                <CDBSidebarMenuItem icon="file-medical"
                className={
                  doctorPage === 'details' ? 'activeNavLink' : 'none'
                }
                >
                  {t('userDetails')}
                </CDBSidebarMenuItem>
              </NavLink>) : <></>
            }

            { 
              selectedPatient !== undefined && selectedPatient !== null && selectedPatient !== '' ?
              (<NavLink
                to="/patients/blood_tests"
                // className={() => (isPatientsActive ? "activeClicked" : "none")}
                onClick={() => {
                  localStorage.setItem('doctor_page', 'blood_tests')
                  setDoctorPage('blood_tests')
                }}
              >
                <CDBSidebarMenuItem icon="vial"
                  className={
                    doctorPage === 'blood_tests' ? 'activeNavLink' : 'none'
                  }
                >
                  {t('bloodAnalysis')}
                </CDBSidebarMenuItem>
              </NavLink>) : <></>
            }

{ 
              selectedPatient !== undefined && selectedPatient !== null && selectedPatient !== '' ?
              (<NavLink
                to="/patients/send_message"
                state={{
                  medicalStaffId: Number(getStaffId()),
                  patientId: selectedPatient,
                  patientData: selectedPatientData
                }}
                onClick={() => {
                  localStorage.setItem('doctor_page', 'chat')
                  setDoctorPage('chat')
                }}
                // className={() => (isPatientsActive ? "activeClicked" : "none")}
              >
                <CDBSidebarMenuItem icon="envelope"
                  className={
                    doctorPage === 'chat' ? 'activeNavLink' : 'none'
                  }
                >
                  {t('sendMessage')}
                </CDBSidebarMenuItem>
              </NavLink>) : <></>
            }
            { 
              selectedPatient !== undefined && selectedPatient !== null && selectedPatient !== '' ?
              (<NavLink
                to="/patients/user_documents"
                state={{
                  medicalStaffId: Number(getStaffId()),
                  patientId: selectedPatient,
                  // patientData: selectedPatientData
                }}
                onClick={() => {
                  localStorage.setItem('doctor_page', 'documents')
                  setDoctorPage('documents')
                }}
                // className={() => (isPatientsActive ? "activeClicked" : "none")}
              >
                <CDBSidebarMenuItem icon="folder-open"
                  className={
                    doctorPage === 'documents' ? 'activeNavLink' : 'none'
                  }
                >
                  {t('documentsPage')}
                </CDBSidebarMenuItem>
              </NavLink>) : <></>
            }

            <NavLink
              to="/doctor_profile"
              onClick={() => {
                setDoctorPage('profile')
                localStorage.setItem('doctor_page', 'profile')
              }}
            >
              <CDBSidebarMenuItem 
                icon="id-card"
                className={isProfileActive ? 'activeNavLink sidebar-icon-large' : 'none sidebar-icon-large'}
              >
                {t("profile")}
              </CDBSidebarMenuItem>
            </NavLink>

          </CDBSidebarMenu>
        </CDBSidebarContent>
      </CDBSidebar>
    </div>
  );
};
